(function($, undefined) {
	
	'use strict';
    var scrollUtil;
    var slider;
    var utils;
    
	var init = function (page) {
		var currPage = $(page);
        utils = Fw.component.models().utils; 
        slider = Fw.component.models().slider;
        scrollUtil = Fw.modules.models().header;
        if ($('.index-slider-ctn-inner').length > 0) { 
            slider.init(currPage);
        }
		mobileMenuBtn();
        updateLabelAsVar();
        openBtnEdit();
        chkField();

        $('.picker-popup').appendTo('body');
		
		$('.index-slider-down-arrow-text.clickable, .index-slider-down-arrow-image-ctn').click(function() {
			scrollToAnchor('index-content-start', 0);
		});        

        var zoomSlick = $('.gallery-popup-img-ctn').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
            fade: true,
            cssEase: 'linear'
        });

        $(window).on('load', function() {
                $('.gallery-popup-img-ctn-inner').each( function(){
                var w = $(this).find('.gallery-popup-img-item-content').width();
                var h = $(this).find('.gallery-popup-img-item-content').height();
                var cw = $('.gallery-popup-img-ctn').width();
                var ch = $('.gallery-popup-img-ctn').height();

                if(h > (w - 165)){
                    $(this).addClass('long');
                }

                if(h > ch){
                    $(this).css('width','auto');
                    $(this).css('height',ch);
                }
            });
        });

        $("body:not(.is-logged-in) .gallery-item-ctn").click(function() {
            var ctnWidth = $('#compo-gallery').outerWidth();

            if(ctnWidth > 750){
                var slideClickedIndex = $(this).data('slickIndex');
                
                $('.gallery-popup').addClass('show');
                $('body').addClass('zoom');
                $('.zoom-toggler').addClass('show');
                zoomSlick.slick('slickGoTo', slideClickedIndex);
            }
        });

        $(".gallery-popup-prev").click(function() {
            var currentSliderIndex = $(this).parent('.gallery-popup-img-ctn-inner').data('slickIndex');
            var slideClickedIndex = $('.slick-current').data('slickIndex');
            var last = $('slick-slide').length;
            var valid = (currentSliderIndex == slideClickedIndex);

            slideClickedIndex = slideClickedIndex - 1;

            if(slideClickedIndex == -1){
                slideClickedIndex = last - 1;
            }

            if(valid){
                zoomSlick.slick('slickGoTo', slideClickedIndex);
            }
        });

        $(".gallery-popup-next").click(function() {
            var currentSliderIndex = $(this).parent('.gallery-popup-img-ctn-inner').data('slickIndex');
            var slideClickedIndex = $('.slick-current').data('slickIndex');
            var last = $('slick-slide').length;
            var valid = (currentSliderIndex == slideClickedIndex);

            slideClickedIndex = slideClickedIndex + 1;

            if(slideClickedIndex == last){
                slideClickedIndex = 0;
            }

            if(valid){
                zoomSlick.slick('slickGoTo', slideClickedIndex);
            }
        });
	};
	
	init();
    
    function mobileMenuBtn(){
        $('.js-mobile-menu').on('click', function(){
            $(this).toggleClass('close');
            $('.site-nav').toggleClass('close');

            $('.fancytitle-wrapper:not(.page-content-container)').toggleClass('hidetitle');
            $('.index-slider-ctn').toggleClass('hidetitle');
            $('.index-slider-down-arrow-text').toggleClass('hide');
            $('.index-slider-down-arrow-image-ctn').toggleClass('hide');

            if($(this).hasClass('close')){
                scrollUtil.toggleScroll(false);
            }else{
                scrollUtil.toggleScroll(true);
            }
        });
    }

    function scrollToAnchor(anchor, offset){
        offset = offset || 0;
        var aTag = $("a[name='"+ anchor +"']");
        $('html,body').animate({scrollTop: aTag.offset().top + offset},'slow');
    }

    function chkField() {
        $('.js-chkfield').click(function(){
            var boo = true;
            var num = 2;
            var pass = chkReqField();

            if(pass === true) {
                sendContactFormEmail(boo, num);
            }
        });
        
    }

    function chkEmailField() {
        var val = false;
        var email = $('.email').val();

        var chkEmpty = (email === "");
        var chkAt = (email.indexOf('@') == -1);
        var chkDot = (email.indexOf('.') == -1);
        var chkLength = (email.length < 7);

        if (chkEmpty || chkAt || chkDot || chkLength) {
            //do nothing invalid email
            $('.email').addClass('alert');
        } else {
            val = true;
            $('.email').removeClass('alert');
        }
        return val;
    }

    function chkReqField() {
        var val = "";
        var chk = true;
        var chkbox = true;
        var emailChk = true;
        var x, minX, aNumber;
        
        try {
            x = parseInt(document.getElementsByClassName("input-number")[0].value);
            minX = document.getElementsByClassName("input-number")[0].min;
            aNumber = (isNaN(x) || x < minX) ? false : true;
        } catch(exception) {
            aNumber = true;
        }
        $("input.requis, textarea.requis").each(function() {
            val = $(this).val();
            if(val === "" || val.replace(/\s/g, "").length === 0) {
                $(this).addClass("alert");
                $(this).parent(".input-container").addClass("alert");
                chk = false;
            } else {
                $(this).removeClass("alert");
                $(this).parent(".input-container").removeClass("alert");
            }
        });
        $("input.requis[type='checkbox']").each(function() {
            var checked = $(this).prop("checked");
            if(checked === true) {
                $("input.requis.alert-o").removeClass("alert-o");
                chkbox = true;
                return false;
            } else if(checked === false) {
                $(this).addClass("alert-o");
                chkbox = false;
            }
        });

        emailChk = chkEmailField();
        
        var finalChk = (chk===true && chkbox===true && aNumber===true && emailChk===true) ? true : false;
        return finalChk;
    }
	

    function updateLabelAsVar(){
        $('.js-updateLabel').click(function(){
            var parent = $(this).parents('.img-pos-setting');
            var labelTag = $(this).attr( "data-js" );
            var param1 = $(parent).find('#img-left-'+labelTag).prop("checked");
            var param2 = $(parent).find('#img-bottom-'+labelTag).prop("checked");
            var param3 = $(parent).find('#img-under-'+labelTag).prop("checked");

            utils.updateLabelLangs('img-pos-'+labelTag, param1+"-"+param2+"-"+param3, 'en,fr');
            location.reload();
        });
    }

    function openBtnEdit(){
        $('.js-openbtn').click(function(){
            $(this).next('.admin-btn').toggle();
        });
    }

})(jQuery);